import styled from '@emotion/styled'

import cx from 'classnames'

import { Button } from '@/legacy/components/Button'
import type { CarouselButtonsProps } from '@/legacy/components/Carousel'
import { Icon } from '@/legacy/components/Icon'
import { CONFIG } from '@/ui/shared/styles'

interface Props extends CarouselButtonsProps {}

const FloatingCarrosselButtonsStyles = styled.div`
  display: flex;
  max-width: 300px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;

  & > * {
    pointer-events: all;
  }

  .carousel-button {
    font-weight: bold;
    font-size: 1.5rem;
    padding: 0rem;
    height: 2.5rem;
    min-width: 2.5rem;
    border-radius: 50%;
    z-index: 4;
    cursor: pointer;
  }

  .carousel-button:focus,
  .carousel-button:not(:active):hover {
    box-shadow: 0 0 12px 6px rgba(var(--colors-surface-lightgray), 0.1);
  }

  .carousel-button:not(:active):focus,
  .carousel-button:not(:active):hover {
    background-color: rgba(var(--colors-surface-lightgray), 0.15);
  }

  @media (min-width: ${CONFIG.maxWidths.lg}) {
    display: block;
    max-width: none;
    .carousel-button {
      position: absolute;
      top: 40%;
      font-size: 3rem;
    }

    .carousel-button.next {
      right: 0;
    }
  }
`

const CarouselLegend = styled.div<Pick<Props, 'colorModifier'>>(
  (props) => `
  margin: auto;
  align-self: end;
  flex: 1 0 auto;
  text-align: center;
  display: -webkit-inline-box;
  white-space: nowrap;
  max-width: 15.65rem;
  display: flex;
  justify-content: center;
  padding:1rem 0;
  button {
    display: inline-flex;
    padding: 0;
    width: 1rem;
    height: 1rem;
    border: 4px solid rgba(var(--colors-${props.colorModifier}));
    background: transparent;
    border-radius: 100%;
    margin: auto 0.25rem;
    cursor: pointer;
    transition: 0.3s ease color;
  }

  button.active {
    background: rgba(var(--colors-${props.colorModifier}));
  }

`,
)

export const FloatingCarrosselButtons = ({
  onNext,
  onPrev,
  onActive,
  currentSlide,
  totalSlides,
  colorModifier = 'primary',
}: Props) => (
  <FloatingCarrosselButtonsStyles className="carousel-floating-controller">
    <Button
      className="carousel-button prev"
      modifier="ghost"
      onClick={onPrev}
      aria-hidden
      tabIndex={-1}
    >
      <Icon color={colorModifier} icon="angle-left" />
    </Button>

    <CarouselLegend className="carousel-legend" colorModifier={colorModifier}>
      {[...new Array(totalSlides)].map((_v, index) => (
        <button
          type="button"
          key={`bgcb-i-${index}`}
          className={cx({ active: index === currentSlide - 1 })}
          onClick={() => onActive(index)}
          aria-hidden
          tabIndex={-1}
          aria-label=""
        />
      ))}
    </CarouselLegend>

    <Button
      className="carousel-button next"
      modifier="ghost"
      onClick={onNext}
      aria-hidden
      tabIndex={-1}
    >
      <Icon color={colorModifier} icon="angle-right" />
    </Button>
  </FloatingCarrosselButtonsStyles>
)

export default FloatingCarrosselButtons
